import { Select, Form } from '@weezevent/nacre';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// TODO use a lib (like https://www.npmjs.com/package/iso-639-1 ) to display languages translate in the actual locale
export const LANGUAGES = {
    'fr-FR': 'Français (France)',
    'fr-CA': 'Français (Canada)',
    'en-GB': 'English (UK)',
    'en-US': 'English (US)',
    'es-ES': 'Español',
    'ca-ES': 'Català',
    'it-IT': 'Italiano',
    br: 'Brezhoneg',
    'nl-NL': 'Nederlands',
    'de-DE': 'Deutsch',
    eu: 'Basque',
    'ru-RU': 'Русский',
    'pt-PT': 'Português',
    'el-GR': 'Ελληνικά',
    'tr-TR': 'Türkçe',
    'en-CA': 'English (Canada)'
};

export const LANGUAGES_CODES = {
    'fr-FR': 1,
    'fr-CA': 38,
    'en-GB': 2,
    'es-ES': 4,
    'nl-NL': 39,
    'de-DE': 40,
    'ca-ES': 41,
    'it-IT': 74,
    'pt-PT': 75,
    br: 21,
    eu: 45,
    'en-US': 46,
    'ru-RU': 66,
    'el-GR': 67,
    'tr-TR': 68,
    'en-CA': 47
};

/**
 * Language selector component.
 * Feature : if an array of lang_code is given (arrayLangDefault) it will display only the languages in this array
 *
 * @param lang
 * @param onChange
 * @param label
 * @param arrayLangDefault
 * @returns {*}
 * @constructor
 */
export function LanguageSelector({ lang, onChange, label, arrayLangDefault = [], errorField }) {
    const { t } = useTranslation();

    if (arrayLangDefault.length > 0) {
        let formattedLangs = arrayLangDefault.map(mlang => {
            if (!mlang) {
                return null;
            }

            if (mlang.length === 2) {
                return mlang.toLowerCase();
            }

            let [l1, l2] = mlang.split('-');
            return `${l1.toLowerCase()}-${l2.toUpperCase()}`;
        });

        formattedLangs = formattedLangs.filter(l => l);

        return (
            <Form.Field>
                <Form.Label>{label}</Form.Label>
                <Select useNew value={lang} options={getLanguageDefault(formattedLangs)} onChange={onChange} />
                <Form.FieldErrors errors={errorField && t(errorField)} />
            </Form.Field>
        );
    }

    let langu = lang.indexOf('-') > -1 ? lang.substring(0, lang.indexOf('-')) + lang.substring(lang.indexOf('-')).toUpperCase() : lang;
    return (
        <Form.Field>
            <Form.Label>{label}</Form.Label>
            <Select useNew value={langu} options={getLanguageOptions()} onChange={onChange} />
            <Form.FieldErrors errors={errorField && t(errorField)} />
        </Form.Field>
    );
}

LanguageSelector.propTypes = {
    lang: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    arrayLangDefault: PropTypes.array
};

/**
 * Return Array containing all languages available
 * @returns {{text: string, value: string}[]}
 */
export const getLanguageOptions = () => {
    return Object.entries(LANGUAGES).map(([key, value]) => ({
        text: value,
        value: key
    }));
};

/**
 * Return array {key:Lang_code, value: Lang_name} for each lang_code contains in tab
 *
 * @param tab array of lang_code
 * @returns {Array}
 */
const getLanguageDefault = tab => {
    let languageArray = [];
    Object.entries(LANGUAGES).forEach(([key, value]) => {
        if (tab && tab.includes(key)) {
            languageArray.push({
                text: value,
                value: key
            });
        }
    });
    return languageArray;
};
